import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {AppPartnerSelectionPopupPage} from "../app-partner-selection-popup/app-partner-selection-popup";

/**
 * Generated class for the AppYubleCodePopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-yuble-code-popup',
  templateUrl: 'app-yuble-code-popup.html',
})
export class AppYubleCodePopupPage extends AppPartnerSelectionPopupPage{
  codeFiltering: string = 'yuble';
  translationPrefix: string = 'Yuble '


  ionViewDidLoad() {
    console.log('ionViewDidLoad AppYubleCodePopupPage');
  }

  redirectToYuble() {
    window.open(
      'https://www.yuble.de/product/57519-APP?parent=%2Fsuche%2FVIDEA%20bewegt%20-%20Ein%20Onlinekurs%20zur%20Ganzk%C3%B6rperkr%C3%A4ftigung%20mit%20Fokus%20auf%20Kraftausdauer',
      '_blank',
      'location=yes'
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-yuble-code-popup/app-yuble-code-popup.ts